<div class="">
  <div class="flex justify-between items-center">
    <span class="font-bold text-gray flex gap-3">
      <fa-icon [icon]="faThermometer2"></fa-icon>
      Zone Bins
    </span>
    <div class="flex gap-1">
      <button *ngxPermissionsOnly="addPermission" (click)="onAdd(null,'upload')" mat-raised-button color="primary" style="background-color: #005590;">
        <mat-icon>upload</mat-icon>
        Upload Bins
      </button>
      <button *ngxPermissionsOnly="addPermission" (click)="onAdd(null,'create')" mat-raised-button color="primary" style="background-color: #005590;">
        <mat-icon>add</mat-icon>
        Add Bins
      </button>
      <a matTooltip="Download sample csv" href="assets/csv_sample/sample_data.csv" download="sample.csv" class="flex items-center justify-center bg-primary-50 rounded-full w-10 h-10 border-2 border-primary-100">
        <mat-icon color="primary">download</mat-icon>
      </a>
    </div>
  </div>
</div>
@if (bins$ | async; as bins) {
<div class=" pb-10 ">
  <div class="p-2 flex flex-wrap gap-1 w-auto h-8">
    @for (bin of bins; track bin.uniqueId) {
    <div class="relative group">
      <!-- Bin number div -->
      <div class="font-semibold py-2 px-5 border m-auto text-primary text-xs">
        {{bin?.binNumber}}
      </div>
      <!-- Icons as overlay, hidden by default -->
      <div class="absolute inset-0 cursor-pointer flex justify-center backdrop-blur-[1px] items-center opacity-0 group-hover:opacity-100 gap-2">
        <mat-icon (click)="onDelete(bin)" class="!text-lg text-red-500">delete</mat-icon>
        <mat-icon (click)="onAdd(bin, 'create')" class="!text-lg text-blue-500">edit</mat-icon>
      </div>
    </div>
    }
  </div>
</div>
@if(pagination$ | async; as pagination){
<div class="flex relative mt-16 w-fit gap-2 border rounded-xl py-2 px-5">
  <button type="" [disabled]="!pagination.hasPreviousPage" (click)="fetchPage(pagination, 'prevPage')">Prev</button>
  <select [ngModel]="pagination.currentPageNumber" (change)="fetchPage(pagination,'default',$event)" class="bg-transparent w-14 text-center">
    @for(page of pagination?.pagesNumberArray; track page){
    <option [value]="page">{{page}}</option>
    }
  </select>
  <button type="" [disabled]="!pagination.hasNextPage" (click)="fetchPage(pagination, 'nextPage')">next</button>
</div>
}

}
